// Słownik polski — single source of truth dla struktury.
// Każdy nowy klucz dodawaj tutaj NAJPIERW, potem do en.ts (TS zmusi do uzupełnienia).
export const pl = {
  meta: {
    title: 'Solid Labs PSA — Premium Partner dla MŚP',
    description:
      'Krakowska firma technologiczna. Dostarczamy nowoczesne rozwiązania cyfrowe wspierane sztuczną inteligencją dla małych i średnich przedsiębiorstw.',
  },
  nav: {
    about: 'O nas',
    product: 'Produkt',
    oferta: 'Oferta',
    realizacje: 'Realizacje',
    contact: 'Kontakt',
    spottoApp: 'Spotto App',
    logoAria: 'Solid Labs — strona główna',
    logoAlt: 'Solid Labs',
    langPlAria: 'Język polski',
    langEnAria: 'Switch to English',
    mobileToggleOpen: 'Otwórz menu',
    mobileToggleClose: 'Zamknij menu',
  },
  hero: {
    title1: 'Tworzymy rozwiązania',
    title2: 'dla biznesu',
    title3: 'napędzane AI',
    subtitle:
      'Solid Labs PSA to krakowska firma technologiczna. Dostarczamy rozwiązania cyfryzujące procesy biznesowe — wzbogacone mocą sztucznej inteligencji. Naszym flagowym produktem jest Spotto, platforma dla branży sportowej.',
    ctaPrimary: 'Poznaj Spotto',
    ctaSecondary: 'O firmie',
    scrollHint: 'Dowiedz się więcej',
  },
  about: {
    eyebrow: 'O firmie',
    titlePart1: 'Technologia spotyka',
    titlePart2: 'biznes',
    intro:
      'Solid Labs PSA to krakowska firma technologiczna z międzynarodowym doświadczeniem. Specjalizujemy się w cyfryzacji procesów biznesowych i automatyzacji wspieranej sztuczną inteligencją — dla klientów z najbardziej wymagających sektorów. Customer excellence i długoterminowe, partnerskie relacje z klientami to fundament, na którym budujemy każdy projekt.',
    facts: {
      operatingSince: {
        title: 'Działamy od 2022 roku',
        description:
          'Krakowska firma technologiczna w formule Prostej Spółki Akcyjnej — funkcjonujemy nieprzerwanie od lipca 2022 roku.',
      },
      digitizationAi: {
        title: 'Cyfryzacja + AI',
        description:
          'Doświadczenie w cyfryzacji procesów, analityce danych, wdrożeniach chmurowych oraz automatyzacji opartej na sztucznej inteligencji.',
      },
      implementations: {
        title: 'Mamy ponad 12 wdrożeń',
        description:
          'Zrealizowaliśmy ponad tuzin projektów dla klientów biznesowych — od dużych korporacji po dynamicznie rosnące spółki.',
      },
      crossSector: {
        title: 'Doświadczenie międzysektorowe',
        description:
          'Banking, Finance, TMT, Energy i Retail — znamy specyfikę i wdrażaliśmy usprawnienia skomplikowanych procesów zakupowych i operacyjnych.',
      },
      solutions: {
        title: 'Realizacje',
        description:
          'Systemy CRM, katalogi produktowe, portale transakcyjne, aplikacje mobilne oraz automatyzacja procesów oparta na danych i AI.',
      },
      international: {
        title: 'Doświadczenie międzynarodowe',
        description:
          'Wieloletnie doświadczenie w projektach międzynarodowych — współpracowaliśmy z firmami Big 4, dużymi spółkami akcyjnymi i innymi podmiotami w Polsce, Europie i USA.',
      },
    },
  },
  privacy: {
    title: 'Polityka prywatności',
    closeAria: 'Zamknij',
    lastUpdated: 'Ostatnia aktualizacja: 11 maja 2026',
  },
  oferta: {
    eyebrow: 'Oferta',
    titlePart1: 'Cyfryzacja dla',
    titlePart2: 'MŚP',
    mission:
      'Naszą misją jest dostarczanie małym i średnim przedsiębiorstwom narzędzi cyfrowych w klasie premium. Upraszczamy, integrujemy i wdrażamy nowoczesne rozwiązania w modelu SaaS — rekurencyjnym abonamencie, który optymalizuje wydatki inwestycyjne i rozkłada koszty w czasie.',
    pillars: {
      saas: {
        title: 'Produkty SaaS',
        description:
          'Gotowe moduły SaaS — integrują się z każdą istniejącą stroną bez konieczności przebudowy. Wystarczy podlinkować je do naszego systemu.',
        items: {
          scheduler: {
            title: 'Scheduler',
            desc: 'Pełny moduł rezerwacji kalendarza i zarządzania nim. Gotowy do osadzenia w dowolnym biznesie usługowym.',
          },
          sklep: {
            title: 'Sklep',
            desc: 'Moduł sprzedażowy z bramką płatności — łatwa integracja z każdą stroną. Dodaje kanał sprzedaży online bez kosztów inwestycyjnych.',
          },
        },
      },
      transformacje: {
        title: 'Transformacje technologiczne',
        description:
          'Wspieramy biznesy w skalowaniu — przez optymalizację procesów sprzedażowych i operacyjnych.',
        items: {
          sales: {
            title: 'Optymalizacja sprzedaży',
            desc: 'Aktywacja kanałów online — szybko, tanio i skutecznie. Łączymy strony, sklepy i automatyzację marketingu.',
          },
          operations: {
            title: 'Optymalizacja operacji',
            desc: 'Automatyzacja procesów wewnętrznych — fakturowanie, obieg dokumentów, raportowanie, integracja systemów.',
          },
        },
      },
      ai: {
        title: 'Automatyzacja z AI',
        description:
          'Wdrożenia AI tam, gdzie wnoszą realną wartość — bez hype’u, z mierzalnym ROI.',
        items: {
          analytics: {
            title: 'Analityka danych',
            desc: 'Dostarczamy wartość przez zrozumienie struktury danych, ich integrację oraz wykorzystanie data insights dla lepszego zarządzania biznesem.',
          },
          integrations: {
            title: 'Integracje AI',
            desc: 'Łączenie modeli językowych z istniejącymi systemami biznesowymi — CRM, ERP, hurtownie danych.',
          },
        },
      },
    },
  },
  product: {
    eyebrow: 'Nasz produkt',
    description1:
      'Platforma, która rewolucjonizuje sposób rezerwacji obiektów sportowych. Znajdź idealne miejsce do uprawiania sportu, zarezerwuj je w kilka sekund i zarządzaj swoimi treningami — wszystko w jednej aplikacji.',
    description2:
      'Dla właścicieli obiektów Spotto to kompleksowe narzędzie do zarządzania rezerwacjami, płatnościami, kalendarzem dostępności i komunikacją z klientami. Transparentne ceny, brak ukrytych opłat.',
    capabilities: {
      search: 'Wyszukiwanie obiektów w okolicy',
      booking: 'Rezerwacja w czasie rzeczywistym',
      payments: 'Bezpieczne płatności online',
      trainers: 'Szukanie trenerów personalnych',
      mobile: 'Aplikacja mobilna iOS i Android',
      panel: 'Panel zarządzania dla właścicieli',
    },
    ctaVisit: 'Przejdź na stronę produktu',
    screens: {
      home: 'Ekran główny',
      explore: 'Przeglądanie obiektów',
      booking: 'Rezerwacja terminu',
      training: 'Zapis na trening',
      shop: 'Sklep',
    },
    carouselAria: 'Wybierz ekran aplikacji',
  },
  realizacje: {
    eyebrow: 'Realizacje',
    title: 'Co już zbudowaliśmy',
    subtitle:
      'Wybrane projekty, w których pomogliśmy klientom przejść przez cyfryzację procesów i wdrożyć rozwiązania wspierane sztuczną inteligencją.',
    projects: {
      spotto: {
        category: 'Platforma sportowa',
        title: 'Spotto',
        description:
          'Aplikacja mobilna i platforma webowa do rezerwacji obiektów sportowych, zarządzania treningami i łączenia sportowców z trenerami.',
      },
      soon: {
        category: 'Case study',
        title: 'Wkrótce',
        description:
          'Kolejne realizacje cyfryzacji procesów biznesowych — w przygotowaniu do publikacji.',
      },
    },
  },
  cta: {
    titlePart1: 'Gotowy na',
    titlePart2: 'współpracę?',
    subtitle:
      'Jeśli prowadzisz biznes sportowy, szukasz partnera technologicznego lub chcesz się dowiedzieć więcej o Spotto — odezwij się do nas.',
    ctaPrimary: 'Napisz do nas',
    ctaSecondary: 'Zobacz Spotto',
  },
  footer: {
    descriptionLine1: 'Krakowska firma technologiczna,',
    descriptionLine2: 'Premium Partner dla Małych i Średnich Przedsiębiorstw.',
    legalForm: 'Prosta Spółka Akcyjna',
    productHeader: 'Produkt',
    companyHeader: 'Firma',
    allRightsReserved: 'Wszystkie prawa zastrzeżone.',
    privacyPolicy: 'Polityka prywatności',
  },
}
